// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"600":"608bc144","739":"608bc144"}[chunkId] + ".chunk.css";
};